import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import ReactPaginate from "react-paginate";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Footer } from "../../../layout/footer";
import { options } from "../../../api";
import { boundaryCRUD } from "../../../actions/boundary";
import { Loading } from "../../constant";
import { AddRegion } from "../region/modal";
import { EditBoundary } from "../region/editModal";
import { UploadBoundary } from "../upload/UploadBoundary";

export const ZoneContent = () => {
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0);
  const [value, setValue] = useState("");
  const [parentList, setParentList] = useState([]);
  const [index, setIndex] = useState(0);
  const [dataId, setDataId] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      boundaryCRUD
        .loadBoundary(postsPerPage, nextPage, "Zone", value)
        .then((resp) => {
          setCount(resp.data.count);
          setData(resp.data.results);
          setPageCount(Math.ceil(resp.data.count / postsPerPage));
        })
        .finally(() => {});
    }, 2000);
  }, [page, postsPerPage, value, index]);

  const handleEdit = (id) => {
    setDataId(id);
  };

  const handleChangePage = (event) => {
    setData([]);
    setPage(event.selected);
    setNextPage(event.selected * postsPerPage);
  };

  const handleChange = (selectedOption) => {
    const sel = selectedOption.value;
    setData([]);
    setePostPerPage(sel);
    setNextPage(0);
    setPage(0);
  };

  const handleSearch = (event) => {
    setData([]);
    setValue(event.target.value);
  };

  useEffect(() => {
    boundaryCRUD
      .loadBoundary(10, 0, "Locality", "")
      .then((resp) => {
        setParentList(resp.data.results);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {});
  }, []);



  return (
    <>
      <ToastContainer />
      <AddRegion setIndex={setIndex} boundaryName="Zone" parentList={parentList} index={index} />
      <EditBoundary dataId={dataId} setIndex={setIndex} index={index} boundaryName="Zone" parentList={parentList} />
      <UploadBoundary setIndex={setIndex} index={index} boundaryType="Zone" parentList={parentList} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Zone</h4>

                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <a href="#">Zone</a>
                      </li>
                      <li className="breadcrumb-item active">List</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col-md-3">
                        <input
                          className="form-control"
                          value={value}
                          onChange={handleSearch}
                          placeholder="search"
                        />
                      </div>
                      <div className="col-md-6"></div>
                      <div className="col-md-3">
                        <div className="row d-flex justify-content-end">
                          <div className="col-auto">
                            <Link
                              to={"/new"}
                              className="btn btn-soft-primary"
                              data-bs-toggle="modal"
                              data-bs-target=".addRegion"
                            >
                              <i className="bi bi-plus-circle bi-lg"></i> &nbsp;
                              New Zone
                            </Link>
                          </div>
                          <div className="col-auto">
                            <button
                              className="btn btn-soft-info"
                              data-bs-toggle="modal"
                              data-bs-target=".uploadBoundaryZoneModal"
                            >
                              <i className="bi bi-upload bi-lg"></i> &nbsp;
                              Upload Zone
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <table
                      id="scroll-vertical"
                      className="table table-bordered dt-responsive nowrap table-striped align-middle mdl-data-table"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th>SR No.</th>
                          <th>Zone Name</th>
                          <th>Code</th>
                          <th>Initials</th>
                          <th>Postcode</th>
                          <th>Boundary Polygon</th>
                          <th>Boundary Centroid</th>
                          <th className="d-flex justify-content-center">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((dt, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>
                              {dt.boundary_name ? dt.boundary_name : "N/A"}
                            </td>
                            <td>{dt.boundary_code ? dt.boundary_code : "N/A"}</td>
                            <td>{dt.boundary_initials ? dt.boundary_initials : "N/A"}</td>
                            <td>{dt.postcode ? dt.postcode : "N/A"}</td>
                            <td>{dt.boundary_polygon ? <span className="badge bg-success">Has Polygon</span> : <span className="badge bg-secondary">No Polygon</span>}</td>
                            <td>{dt.boundary_centroid ? `${dt.centroid_lat?.toFixed(6)}, ${dt.centroid_lng?.toFixed(6)}` : 'N/A'}</td>
                            <td className="text-center">
                              <div className="dropdown d-inline-block">
                                <button
                                  className="btn btn-soft-secondary btn-sm dropdown"
                                  type="button"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <i className="ri-more-2-fill align-middle"></i>
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end">
                                  <li>
                                    <button
                                      onClick={() => handleEdit(dt.id)}
                                      className="dropdown-item edit-item-btn"
                                      data-bs-toggle="modal"
                                      data-bs-target=".editBoundary"
                                    >
                                      <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>{" "}
                                      Edit
                                    </button>
                                  </li>
                                  <li>
                                    <Link
                                      to={"/map"}
                                      state={{
                                        type: "boundary",
                                        subType: "zone",
                                        id: dt.id,
                                      }}
                                      className="dropdown-item remove-item-btn"
                                    >
                                      <i className="ri-map-pin-line align-bottom me-2 text-muted"></i>{" "}
                                      Map
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {!data.length && <Loading />}
                    <div className="row">
                      <div className="col-md-2">
                        <p>
                          <span>Showing </span>
                          <span>{data.length}</span> of <span>{count}</span>{" "}
                          entries
                        </p>
                      </div>
                      <div className="col-md-5"></div>
                      <div className="col-md-5">
                        <div className="row g-2 justify-content-start justify-content-md-end align-items-center">
                          <div className="col-auto" style={{ marginTop: -8 }}>
                            <Select
                              options={options}
                              defaultValue={options[1]}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="col-auto paginate">
                            <ReactPaginate
                              previousLabel={
                                <i className="las la-angle-double-left la-lg"></i>
                              }
                              nextLabel={
                                <i className="las la-angle-double-right la-lg"></i>
                              }
                              breakLabel={"..."}
                              breakClassName={"break-me"}
                              marginPagesDisplayed={2}
                              pageRangeDisplayed={3}
                              pageCount={pageCount}
                              onPageChange={handleChangePage}
                              containerClassName={"pagination"}
                              subContainerClassName={"pages pagination"}
                              activeClassName={"active"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};
